export default "__VITE_ASSET__D1NO9T6j__"